import instance from '@/services/repository';

const resource = '/externalInvoices';

export default {
    lookup(options: any, projectId?: string, supplierId?: string) {
        const formData = new FormData();

        for ( const key in options ) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        let query = '';
        if (projectId && projectId !== '') {
            query += '?projectId=' + projectId;
            if (supplierId && supplierId !== '') {
                query += '&supplierId=' + supplierId;
            }
        } else {
            if (supplierId && supplierId !== '') {
                query += '?supplierId=' + supplierId;
            }
        }

        return instance
            .post(`${resource}/lookup${query}`,
                formData,
                {
                    headers: {'Content-Type': 'multipart/form-data' },
                });
    },
    getSingle(id: string) {
        return instance.get<IExternalInvoice>(`${resource}/${id}`);
    },
    downloadDocument(id: string) {
        return instance
            .get<Blob>(`${resource}/${id}/File`, { responseType: 'blob' });
    },
    getContractUrl(id: string) {
        return instance.get<string>(`${resource}/${id}/ContractUrl`);
    },
    /*create(payload: IMachineryRentalCreateCommand) {
        return instance.post<IMachineryRental>(`${resource}`, payload);
    },*/
    update(payload: IExternalInvoice) {
        return instance.put<IExternalInvoice>(`${resource}/${payload.id}`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
    create(payload: IUploadChunkDto, projectId?: string) {
        const formDataToUpload = new FormData();
        formDataToUpload.append('file', payload.file, payload.metaData.fileName);
        formDataToUpload.append('path', '');
        formDataToUpload.append('metaData[index]', '' + payload.metaData.index);
        formDataToUpload.append('metaData[totalCount]', '' + payload.metaData.totalCount);
        formDataToUpload.append('metaData[fileSize]', '' + payload.metaData.fileSize);
        formDataToUpload.append('metaData[fileName]', '' + payload.metaData.fileName);
        formDataToUpload.append('metaData[fileType]', '' + payload.metaData.fileType);
        formDataToUpload.append('metaData[fileGuid]', '' + payload.metaData.fileGuid);

        const query = projectId ? '?projectId=' + projectId : '';
        return instance.post(`${resource}${query}`,
            formDataToUpload, {
            headers: {'Content-Type': 'multipart/form-data' },
        });
    },
    approve(id: string) {
        return instance.post(`${resource}/${id}/Approve`);
    },
    deny(id: string) {
        return instance.post(`${resource}/${id}/Deny`);
    },
    setPaid(id: string) {
        return instance.post(`${resource}/${id}/paid`);
    },
    resetStatus(id: string) {
        return instance.post(`${resource}/${id}/reset`);
    },
};
